import React from 'react';
import { CombinedSessionsPanel } from './CombinedSessionsPanel';
import './SessionsOverlay.css';

interface Session {
  sessionId: number;
  player1: string | null;
  player2: string | null;
  state: string;
  p1CellId?: number;
  p2CellId?: number;
  p1Country?: number;
  p2Country?: number;
  createdLedger?: number;
  players?: Array<{ address: string; cell_id: number; asset_tag: any; country: number; location_proof?: any }>;
  isPublic?: boolean;
  is_public?: boolean;
  trustGroupIds?: number[];
}

interface SessionsOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  userCurrentSession: number | null;
  activeSessions: Session[];
  walletAddress: string | null;
  onJoinSession: (sessionId: number) => Promise<void>;
  onEndSession: (sessionId: number, isPlayer1: boolean, isPlayer2: boolean, sessionState: string) => Promise<void>;
  onViewSessionDetails: () => void;
  contractClient: any;
  isAdmin?: boolean;
  onDeleteSession?: (sessionId: number) => Promise<void>;
  onDeleteAllSessions?: () => Promise<void>;
  /** Narrow the map to only members of the given trust group(s). */
  onShowOnlyTrustGroups?: (groupIds: number[]) => void;
}

export const SessionsOverlay: React.FC<SessionsOverlayProps> = ({
  isOpen,
  onClose,
  userCurrentSession,
  activeSessions,
  walletAddress,
  onJoinSession,
  onEndSession,
  onViewSessionDetails,
  contractClient,
  isAdmin = false,
  onDeleteSession,
  onDeleteAllSessions,
  onShowOnlyTrustGroups,
}) => {
  if (!isOpen) return null;

  return (
    <div className="overlay-backdrop" onClick={onClose}>
      <div className="sessions-overlay" onClick={(e) => e.stopPropagation()}>
        <div className="overlay-header">
          <h2>Sessions</h2>
          <button className="overlay-close-button" onClick={onClose}>×</button>
        </div>
        <div className="sessions-overlay-content">
          <CombinedSessionsPanel
            userCurrentSession={userCurrentSession}
            activeSessions={activeSessions}
            walletAddress={walletAddress}
            onJoinSession={onJoinSession}
            onEndSession={onEndSession}
            onViewSessionDetails={onViewSessionDetails}
            contractClient={contractClient}
            isAdmin={isAdmin}
            onDeleteSession={onDeleteSession}
            onDeleteAllSessions={onDeleteAllSessions}
            onShowOnlyTrustGroups={onShowOnlyTrustGroups}
          />
        </div>
      </div>
    </div>
  );
};
